<template>
  <div class="gc-footer">
    <span v-if="standardSetLabel" :class="{locked: blurLock}">{{ standardSetLabel }}</span>
    <span v-if="standardRef" :class="{locked: blurLock}">{{ standardRef }}</span>
    <popover
      placement="bottom"
      trigger="hover-focus"
      custom-class="popover-as-tooltip goalcard-popover"
    >
      <div
        v-if="showProgress || hasNonEnglishLanguages() || showGrow"
        class="icons"
        tabindex="0"
        :aria-label="ariaLabel()"
      >
        <span
          v-if="hasNonEnglishLanguages()"
          class="globe-icon"
        ><i class="fa fa-globe" /></span>
        <span
          v-if="showProgress"
          class="progress-icon"
          v-html="pmaSvg"/>
        <span
          v-if="showGrow && betaVisibility"
          class="grow-icon"
          v-html="growSvg"/>
      </div>
      <template slot="popover">
        <div class="tooltip-inner">
          <div v-if="showProgress" class="tooltip-inner-container">
            <span
              class="progress-icon"
              v-html="pmaSvg"
              aria-hidden="true"
            />
            <p>Progress monitoring assessments and data sheets</p>
          </div>
          <div v-if="hasNonEnglishLanguages()" class="tooltip-inner-container">
            <i class="fa fa-globe" aria-hidden="true"/>
            <p>Includes assessments in <b>{{ formatLanguages() }}</b></p>
          </div>
          <div v-if="showGrow && betaVisibility" class="tooltip-inner-container">
            <span
              class="grow-icon"
              v-html="growSvg"
              aria-hidden="true"
            />
            <p>Can be tracked in Goalbook Grow if saved to the Library</p>
          </div>
        </div>
      </template>
    </popover>
  </div>
</template>

<script>
import { pmaSvg, growSvg } from '@/icons'
import { mapGetters } from 'vuex'

export default {
  name: 'GoalCardFooter',
  props: {
    standardSetLabel: {
      type: String,
      default: ''
    },
    standardRef: {
      type: String,
      default: ''
    },
    showProgress: {
      type: Boolean,
      default: false
    },
    resourceLanguages: {
      type: Array,
      default: () => []
    },
    blurLock: {
      type: Boolean,
      default: false
    },
    showGrow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pmaSvg: pmaSvg,
      growSvg: growSvg
    }
  },
  methods: {
    formatLanguages() {
      return this.resourceLanguages.reduce((filtered, lang) => {
        if (lang !== 'english') {
          filtered.push(this.capitalize(lang));
        }
        return filtered;
      }, []).join(', ')
    },
    capitalize(lowerString) {
      const lower = lowerString.toLowerCase();
      return lowerString.charAt(0).toUpperCase() + lower.slice(1);
    },
    ariaLabel() {
      let label = '';
      if (this.hasNonEnglishLanguages()) {
        label += 'Has assessments in multiple languages, including ' + this.formatLanguages() + '. '
      }
      if (this.showProgress) {
        label += 'Has progress monitoring assessments and data sheets. '
      }
      if (this.showGrow && this.betaVisibility) {
        label += 'This goal can be tracked in Goalbook Grow if saved to the Library.'
      }
      return label
    },
    hasNonEnglishLanguages() {
      return this.resourceLanguages?.some((lang) => lang != 'english')
    },
  },
  computed: {
    ...mapGetters({
      betaVisibility: 'visibility/betaVisibility'
    })
  }
}
</script>

<style lang="less" scoped>
@import './colors.less';

.gc-footer {
  color: @textPrimary;
  font-size: 12px;
  line-height: 16px;
  height: 16px;

  display: flex;
  align-items: center;
  .icons {
    margin-left: auto;
    color: black;

    .progress-icon, .globe-icon, .grow-icon {
      display: inline-block;
      vertical-align: text-top;
      margin: auto;
    }
    .globe-icon i {
      font-size: 16px;
    }
    .grow-icon {
      margin-left: 2px;
      width: 15px;
    }
  }

  .icons .progress-icon {
    padding-top: 2px;
    margin-left: auto;
  }
  .icons span {
    margin-right: 0.45em;
  }

  span:last-of-type {
    margin-left: auto;
  }
}
</style>
<style lang="less">
.tooltip-inner {
  text-align: left;
  color: white;
  max-width: 230px;
  font-size: 12px;
  p {
    padding: 6px 6px 0px 6px;
  }
  i {
    margin-left: 2px;
    margin-right: 2px;
    font-size: 18px;
    margin-top: 5px;
  }
  svg {
    width: 19px;
    height: 18px;
    margin: 5px 3px 0px 3px;
  }
  .progress-icon {
    svg {
      width: 14px;
      height: 14px;
      margin: 4px 2px 0px 2px;
    }
  }
  .grow-icon {
    margin-left: -2px;
    width: 16px;
    height: 14px;
  }
  .tooltip-inner-container {
    display: flex;
  }
}
</style>

<style lang="less">
.goalcard-popover {
  .popover-content {
    padding: 2px !important;
  }
}
</style>
